import React from 'react';

import { Control } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { routes } from '@vlapps/point/src/app/routes';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import type { ViewCardProps } from './types';

function ViewCardButton({
  cardId,
  className = undefined,
  'data-testid': dataTestId = 'personDetailsButton',
  ...props
}: ViewCardProps & ButtonProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Control.Button
      className={className}
      data-testid={dataTestId}
      kind="secondary"
      size="small"
      variant="outlined"
      {...props}
      as="a"
      href={generatePath(routes.externalId.read, { externalId: cardId })}
    >
      {t('card-list-page:person card.details')}
    </Control.Button>
  );
}

export { ViewCardButton };
